import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MessengerSvgrepoCom1Icon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M12 1.49707C6.19976 1.49707 1.49707 5.85053 1.49707 11.2219C1.5277 14.329 3.04975 17.0738 5.3814 18.7779L5.40854 18.7963V22.5029L8.98653 20.5406C9.88891 20.7988 10.9252 20.9467 11.9965 20.9467H12C17.8002 20.9467 22.5029 16.5924 22.5029 11.2228C22.5029 5.85316 17.8002 1.49707 12 1.49707ZM13.0424 14.5933L10.3685 11.7374L5.14946 14.5907L10.8902 8.49902L13.6306 11.3514L18.7849 8.49902L13.0424 14.5933Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MessengerSvgrepoCom1Icon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MessengerSvgrepoCom1Icon;
